import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes';
import axios from 'axios';
import { Dimmer } from '../spinner';

import { ActualizarPresupuesto } from './modalActuPresupuestos';
import CardsModule from '../cartas';

const TablaPresupuesto = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
  const espiritu = JSON.parse(localStorage.getItem('espiritu'));
  // let municipios = [];

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'AUXILIAR', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [presupuesto, setPresupuesto] = useState();
  const [catpro, setCatpro] = useState();
  const [claspre, setClaspre] = useState();
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {

            if (x.cuenta.includes(target.value)
              || x.auxiliar.toLowerCase().includes(target.value.toLowerCase())
              || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const SeleccionarRegistros = () => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/registrodecuentaspresupuestarias?id=${idefiscal}`
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        /*var datos = []
        var nomcat;
        var nompuc;
        var fusion;
        var fusiondos;
        var cat;
        var puc;

        for (let i = 0; i < response.data.length; i++) {

          nomcat = response.data[i].descripcap.trim();
          nompuc = response.data[i].descripuc.trim();
          fusion = nomcat + '(' + nompuc + ')';

          cat = response.data[i].categoriaprogramatica.trim();
          puc = response.data[i].puc.trim();
          fusiondos = cat + '(' + puc + ')';

          datos.push({
            idcuenta: response.data[i].idcuenta,
            descripcion: fusion,
            catpuc: fusiondos,
            auxiliar: response.data[i].auxiliar
          })

        }*/
       console.log(response.data)
        setRecords(response.data);

        /* setRecords(response.data); */
        txtBuscador.current.focus()
      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SeleccionarPresupuesto = (id) => {

    setActivate(true);

    let campos = "*"
    let nomtab = "cuentapresupuestaria";
    let nomid = "idcuenta";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idcuenta > 0) {
          setPresupuesto(response.data);
          seleccionarCatProgramatica(response.data);
        } else {
          setPresupuesto()
          seleccionarCatProgramatica(response.data);
        }
        setActivate(false);
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const seleccionarCatProgramatica = (data) => {

    setActivate(true);

    let campos = "*"
    let nomtab = "categoriaprogramatica";
    let nomid = "idcategoriaprogramatica";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idcategoriaprogramatica}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idcategoriaprogramatica > 0) {
          setCatpro(response.data);
          seleccionarClasPresupuestario(data);
        } else {
          setCatpro()
          seleccionarClasPresupuestario(data);
        }
        setActivate(false);
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const seleccionarClasPresupuestario = (data) => {

    setActivate(true);

    let campos = "*"
    let nomtab = "puc";
    let nomid = "idpuc";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idpuc}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idpuc > 0) {
          setClaspre(response.data);
          setMostrar2(true);
        } else {
          setClaspre()
          setMostrar2(true);
        }
        setActivate(false);
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }


  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionarCtaPresupuestaria = (op, id) => (e) => {

    if (op === 4) {
      setOperacion(4);
      SeleccionarPresupuesto(id);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true)
    } else if (op === 2) {
      setOperacion(op);
      SeleccionarPresupuesto(id);
    }

  }


  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  }

  const cerrar = () => {
    props.menu()
  }

  const imprimirReporte = () => {

    var reporte;
    var ope = 2
    if (espiritu === 10) {
      if (ope === 1) {
        reporte = 'Pres_FormulacionCab';
      } else {
        reporte = 'Pres_FormulacionOrdinalCab';
      }
    } else {
      if (ope === 1) {
        reporte = 'Pres_Formulacion';
      } else {
        reporte = 'Pres_FormulacionOrdinal';
      }
    }
    window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

  }



  return (
    <section className='mx-auto col-9 rounded '>
      <CardsModule
          total={records.length}
          title2={'Tipo Ingreso'}
          title3={'Tipo Gastos'}

          activos={records.filter(record => record.tipopartida === 0).length}
          inactivos={records.filter(record => record.tipopartida !== 0).length}
        />
      <header className='header-azulGradiant'> 
        <h3 >
          Cuentas Presupuestarias
        </h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input col-3 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />

        <button title='Reporte' onClick={imprimirReporte}  style={{ marginBottom: "5px" }} className="btn btn-sm btn-danger rounded-circle ml-auto mr-2"><i className="fas fa-print"> </i> </button>
        <button title='Registrar'  onClick={gestionarCtaPresupuestaria(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>

      </div>
      <div className="col-md-12 m-0" >
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index + item.idcuenta} style={{ padding: "0" }}>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '120px' }}>{item.cuenta}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{item.auxiliar}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '250px' }}>{espiritu === 7 || espiritu === 8 ? item.descripcuenta : item.descripcion}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>
                    <button onClick={gestionarCtaPresupuestaria(4, item.idcuenta)} title='Consultar' style={{ margin: 'auto 2px' }} className="btn btn-sm align-middle btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                    <button onClick={gestionarCtaPresupuestaria(2, item.idcuenta)} title='Reversar' style={{ margin: 'auto 2px' }} className="btn btn-sm align-middle btn-success rounded-circle"><i className="fas fa-sync-alt"></i></button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ActualizarPresupuesto
        show={mostrar2}
        operacion={operacion}
        presu={presupuesto}
        categoria={catpro}
        claspre={claspre}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />


      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaPresupuesto;